import { Role } from '../types/Role';

export const API_URL = 'api';
export const ADMIN_API_URL = 'api/admin';

export enum Endpoints {
    FUEL_TRANSACTION = 'fueltransactions',
    USERS = 'users',
    SAVINGS = 'savings',
    CONSUMPTION = 'consumption',
    INCONSISTENCYCHECK = 'inconsistencycheck',
    TOTALS = 'totals',
    CAR = 'car',
    REQUESTS = 'requests',
}

type BaseClientProps = {
    role?: Role;
    useAdminRoute?: boolean;
};

/**
 * @returns BaseClient object with functions to get the api url and headers
 */
export const BaseClient = ({ role, useAdminRoute }: BaseClientProps) => {
    let apiEndpoint = API_URL; // Defaults to user role

    if (role === Role.ADMIN || useAdminRoute) {
        apiEndpoint = ADMIN_API_URL;
    }

    const getApiUrl = (endpoint: Endpoints) => {
        return `${window.location.origin}/${apiEndpoint}/${endpoint}`;
    };

    return {
        getApiUrl,
    };
};

export const getHeaders = (accessToken: string) => {
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
    };
};
